import { t } from 'Locale';

/** @param minutes {number} */
export const getNotificationText = (minutes) => {
    if (minutes === 0) return `${t('NOTIFICATION.ALERT_STARTING_NOW')}.`;
    return `${t('NOTIFICATION.ALERT')} ${minutes} ${t('COMMON.MINUTES')}.`;
};
